<footer class="footer" role="contentinfo">
    <div class="row">
    <div class="col">
        <p class="copyright">&copy; Persistent Objects Ltd {{ copyright }}</p>
    </div>
    <div class="col">
      <p class="text-right"><a
        (click)="onPrivacyClick()"
        i18n="Privacy and cookies">MENU_PRIVACY</a></p>
    </div>
    </div>
</footer>
<div id="gdprText" class="d-none" i18n>MESSAGE_COOKIES</div>
<div id="gdprMore" class="d-none" i18n>BUTTON_MORE</div>
<div id="gdprClose" class="d-none" i18n>BUTTON_CLOSE</div>
